import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=7f22aade&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=js"
export * from "./DeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=7f22aade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22aade",
  null
  
)

export default component.exports